var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftBar" },
    [
      _c("v-drawer", { attrs: { direction: "left", width: "26%" } }, [
        _c(
          "div",
          { staticClass: "animated fadeInLeftBig dx" },
          [
            _c(
              "bar-card",
              { staticClass: "lefts lefts1", attrs: { bg: "border-new" } },
              [
                _c("g-title", [_vm._v("渔业经济")]),
                _c("div", { staticClass: "panelContent" }, [_c("left-top")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "jjzw" } }, [
                  _vm._v("水产养殖情况"),
                ]),
                _c("div", { staticClass: "panelContent" }, [_c("left-mid")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "sg" } }, [
                  _vm._v("各区水产品产量对比"),
                ]),
                _c("div", { staticClass: "panelContent" }, [_c("left-bot")], 1),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }